import {Component, HostBinding, Input} from "@angular/core";
import {FUIActionButtonComponent} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-secondary-button",
    styleUrls: ["./secondary-button.component.scss"],
    templateUrl: "secondary-button.component.html"
})
export class SecondaryButtonComponent {
    @Input() @HostBinding("class.disabled") disabled: boolean;
    @Input() public title: string;
    @Input() icon: string;
}
